/**
 * ConnectivityIndicator.js
 *
 * Persistent header bar that shows Online (green) / Offline (red) status.
 * Designed to be ultra-lightweight and rendered at the very top of the screen.
 */

import React, {memo} from 'react';
import {StyleSheet, Text, View} from 'react-native';
import {useOfflineSyncContext} from '../helpers/OfflineSyncContext';

const ConnectivityIndicator = () => {
  const { isOnline } = useOfflineSyncContext();
  const online = isOnline;

  // When online we collapse to zero height so it doesn't occupy space
  if (online) return null;

  return (
    <View style={styles.bar}>
      <View style={[styles.dot, styles.dotOffline]} />
      <Text style={styles.text}>Offline – orders are saved locally</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#dc3545',
    paddingVertical: 4,
    paddingHorizontal: 12,
    zIndex: 9999,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 6,
  },
  dotOffline: {
    backgroundColor: '#fff',
  },
  text: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },
});

export default memo(ConnectivityIndicator);


